<template>
    <base-modal hide-header hide-footer @close="close" size="lg">
        <div class="col-12 nopads" @click.stop="cancelClick($event)">
            <div class="col-sm-12 editor-form">
                <h2 class="editor-header">
                    {{ $t('observations.edit_observations') }}
                </h2>
                <div class="row">
                    <div class="col-sm-8">
                        <open-contract-filter
                            :from="now"
                            :show-company="true"
                            :show-title="true"
                            :apply-padding="false"
                            :showOnlyMyContractsOption="false"
                            @loading="loading=true"
                            @loadingCompleted="loading=false"
                            @contractSelected="setContract"
                        />
                    </div>
                    <div class="col-sm-4">
                        <!-- order selection -->
                        <span class="span-title">{{ $t('observations.orders') }}</span>
                        <select
                            id="order"
                            v-model="order"
                            class="form-select form-select-sm mb-3"
                            :disabled="orders.length < 1"
                        >
                            <option :value="null">
                                {{ $t('observations.select_order') }}
                            </option>
                            <option v-for="option in orders" :key="option.id" :value="option.id">
                                {{ getOrderStringWithInfo(option) }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row px-2">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('observations.closed_time') }}</span>
                        <date-time-picker
                            v-model:date="closedTime"
                            format="dd.MM.yyyy HH:mm"
                            :enableTimePicker="true"
                            :placeholder="$t('observations_videos.search_input_format')"
                        />
                    </div>
                    <div class="col-sm-2 px-0 mx-0" style="padding-top: 1.6em">
                        <button v-if="closedTime" class="btn btn-sm btn-outline-success form-button" @click="openObservation">
                            {{ $t('common.do_open') }}
                        </button>
                        <button v-else class="btn btn-sm btn-outline-primary form-button" @click="closeObservation">
                            {{ $t('common.close') }}
                        </button>
                    </div>
                    <div class="col-sm-3 px-3">
                        <span class="span-title">{{ $t('observation_list.archived') }}</span>
                        <input
                            id="checkbox_archived"
                            type="checkbox"
                            v-model="archived"
                            class="form-check-input mb-3"
                        />
                    </div>
                </div>
                <div class="col-sm-12 text-end mt-2 pt-2">
                    <button class="btn btn-secondary form-button" @click.stop="close">
                        {{ $t('common.cancel') }}
                    </button>
                    <button
                        :disabled="loading"
                        class="btn btn-success form-button"
                        @click.stop="submitObservation"
                    >
                        {{ $t('common.save') }}
                    </button>
                </div>
            </div>
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </base-modal>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import {orderMixin} from "@/components/mixins/OrderMixin";
import {observationHelper} from "@/components/mixins/ObservationMixin";
import DateTimePicker from "@/components/common/DateTimePicker";
import {inject} from "vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'ObservationBulkEditor',
    components: {BaseModal, OpenContractFilter, DateTimePicker},
    mixins: [restApi, orderMixin, observationHelper],
    props: {
        observations: {
            type: Array,
            default: function () {
                return []
            }
        },
        user: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            loading: false,
            closedTime: null,
            customer: null,
            archived: null,
            contractor: null,
            contract: null,
            contracts: [],
            orders: [],
            order: null
        }
    },
    computed: {
        now() {
            return new Date().toISOString();
        }
    },
    methods: {
        openObservation() {
            this.closedTime = null
        },
        closeObservation() {
            this.closedTime = new Date(new Date().getTime() - 60 * 1000)
        },
        setCustomer: function (customer) {
            this.customer = customer
            this.fetchOrders()
        },
        setContractor: function (contractor) {
            this.contractor = contractor
        },
        setContract: function (contract) {
            this.contract = contract
            if (contract) {
                this.fetchOrders()
            }
        },
        fetchOrders: function () {
            this.order = null
            this.loading = true
            var params = {}
            if (this.customer) {
                params.customer = this.customer
            }
            if (this.contract) {
                params.contract = this.contract.id
            }
            params.open = 1 // Get orders only for
            // open or in progress contracts
            this.restFetchParams(this.orderUrl, params, this.handleOrders)
        },
        handleOrders: function (response) {
            this.orders = response.data
            this.loading = false
        },
        submitObservation: function () {
            this.loading = true
            var params = {}
            var obsIds = []
            this.observations.forEach(function (observation) {
                obsIds.push(observation.id)
            })
            params.observations = obsIds
            if (this.contract) {
                params.contract_id = this.contract.id
            }
            if (this.order) {
                params.order_id = this.order
            }
            if (this.closedTime) {
                params.closed_time = this.closedTime
            } else {
                params.closed_time = 'open'
            }
            if(this.archived) {
                params.archived = this.archived
            }
            if(params.observations && params.observations.length > 0) {
                // Bulk update of many observations
                this.restAdd(this.observationsUrl, params, this.success, this.fail)
            }
        },
        success: function () {
            this.loading = false
            this.$emit('closeAndUpdate', this.observation)
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_update_failed'))
        },
        close: function () {
            this.assignmentMode = false
            this.$emit('close')
        },
        cancelClick: function (e) {
            e.stopPropagation()
        }
    }
}
</script>
<style scoped>
</style>

